<div class="d-flex justify-content-start align-items-center pointer mayne-checkbox {{cssClass}} {{colour}} size-{{size}}"
  (click)="itemClicked( $event )" [ngClass]="checked ? 'active' : 'inactive'">
  <div *ngIf="!reverse">
    <fa-icon [icon]="checked ? faCheckbox : faCheckboxUnchecked"></fa-icon>
  </div>
  <div>{{text}}</div>
  <div *ngIf="reverse">
    <fa-icon [icon]="checked ? faCheckbox : faCheckboxUnchecked"></fa-icon>
  </div>
</div>